import React, { useState, useRef, useEffect } from "react";
import { Card, Form, Button, Badge, Image } from "react-bootstrap";
import { Edit3, Camera } from "lucide-react";
// import { Image as ImageIcon } from 'lucide-react';
import { useLocation, useNavigate } from "react-router-dom";

import { ReactComponent as ImageIcon } from "../../../../assets/images/upload-img.svg";
import { ReactComponent as DoenIcon } from "../../../../assets/images/menu-down.svg";
import CreatePostModal from "../create-post-modal/CreatePostModal";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Select from "react-select";
import { LayoutGrid } from "lucide-react";

const PostComposer = ({
  createPost,
  categories,
  isLoading,
  onPostSubmit,
  activeTag,
  onTagChange,
  pendingPostText,
  onBeforeOpen,
}) => {
  const [postContent, setPostContent] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  // const [activeTag, setActiveTag] = useState(null);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [openWithPoll, setOpenWithPoll] = useState(false);
  const fileInputRef = useRef(null);
  const store = useSelector((state) => state.auth);
  const selectRef = useRef(null);
  const [showTagSelect, setShowTagSelect] = useState(false);
  const [localActiveTag, setLocalActiveTag] = useState(activeTag);
  const location = useLocation();
  const navigate = useNavigate();

  const setActiveTag = onTagChange;
  useEffect(() => {
    setLocalActiveTag(activeTag);
  }, [activeTag]);

  // ============= HANDLE PENDING POST TEXT =============
  /**
   * Check for pendingPostText prop and auto-open modal with pre-filled content
   */
  useEffect(() => {
    if (pendingPostText) {
      setPostContent(pendingPostText);
      setShowCreateModal(true);
    }
  }, [pendingPostText]);

  // Use first category as default when categories load
  React.useEffect(() => {
    if (categories && categories.length > 0 && !activeTag) {
      setActiveTag(categories[0].category_name);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [categories]); // Only depend on categories, not activeTag

  // Get available tags from categories
  const availableTags = categories?.map((cat) => cat.category_name) || [];

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);

      if (file.type.startsWith("image/")) {
        const url = URL.createObjectURL(file);
        setPreviewUrl(url);
      } else {
        setPreviewUrl(null);
      }
    }
  };

  const clearSelectedFile = () => {
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
    }
    setSelectedFile(null);
    setPreviewUrl(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const selectTag = (tag) => {
    setActiveTag(tag);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // This is handled by CreatePostModal
    // Just open modal when user types here
    handleOpen();
  };

  const handleOpen = () => {
    if (onBeforeOpen?.()) return;
    setOpenWithPoll(false);
    setShowCreateModal(true);
  };

  const handleOpenWithPoll = () => {
    if (onBeforeOpen?.()) return;
    setOpenWithPoll(true);
    setShowCreateModal(true);
  };
  // const tagOptions =
  // categories?.map((cat) => ({
  //   value: cat.category_name,
  //   label: cat.category_name,
  // })) || [];

  const tagOptions =
    categories?.map((cat) => ({
      value: cat.category_name,
      label: cat.category_name,
    })) || [];

  const selectedTagOption =
    tagOptions.find((opt) => opt.value === localActiveTag) || null;
useEffect(() => {
  if (
    location.state?.action === "OPEN_COMMUNITY_POST" &&
    location.state?.jobContent
  ) {
    setPostContent(location.state.jobContent);
    setShowCreateModal(true);

    // Clean router state so it doesn't reopen on refresh
    navigate(location.pathname, { replace: true });
  }
}, [location.state, navigate, location.pathname]);

  return (
    <Card
      className="post-composer-card"
      data-tour="cm-compose"
      style={{ margin: 0, marginBottom: 0 }}
    >
      <Card.Body style={{ margin: 0, marginBottom: 0 }}>
        <Form onSubmit={handleSubmit}>
          <div className="composer-row d-flex align-items-center">
            <Image
              src={`${process.env.REACT_APP_API_BASE_URL}/uploads/user_profile/${store?.user?.profile_photo_path}`}
              roundedCircle
              alt="User"
              className="img"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = `https://ui-avatars.com/api/?name=${encodeURIComponent(
                  store?.user?.full_name || "User"
                )}&background=0195D3&color=fff&size=40`;
              }}
            />

            <div
              role="button"
              tabIndex={0}
              onClick={handleOpen}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  handleOpen();
                }
              }}
              className={`composer-input border-0 ${!postContent ? "is-placeholder" : ""}`}
              aria-label="Share something with the community"
            >
              {postContent || "Share something with the community..."}
            </div>
            {/* <button
              type="button"
              onClick={() => setShowCreateModal(true)}
              className='pencil-btn'
              title="Create post"
            >
              <Edit3 size={20} />
            </button> */}

            {/* <input
              ref={fileInputRef}
              type="file"
              accept="image/*,video/*"
              onChange={handleFileSelect}
              style={{ display: "none" }}
            /> */}
            <button
              type="button"
              onClick={handleOpen}
              className="camera-btn"
              data-tour="cm-compose-camera"
              aria-label="Add photo"
            >
              <Camera size={20} />
            </button>

            <Button
              type="button"
              onClick={handleOpen}
              className="post-btn"
              data-tour="cm-compose-post"
            >
              Post
            </Button>

            <Button
              type="button"
              onClick={handleOpenWithPoll}
              className="post-btn poll-composer-btn"
              data-tour="cm-compose-poll"
              style={{ marginLeft: "8px" }}
            >
              Poll
            </Button>

            {/* Tag Icon Button — temporarily disabled per new design */}
            {/* <button
              size="sm"
              type="button"
              className="upload"
              onClick={() => setShowTagSelect((prev) => !prev)}
            >
              <LayoutGrid />
            </button> */}

            {/* React Select — temporarily disabled per new design */}
            {/* {showTagSelect && (
              <div className="tag-select-wrapper">

                <Select
                  ref={selectRef}
                  options={tagOptions}
                  value={selectedTagOption}
                  menuIsOpen
                  controlShouldRenderValue={false}
                  isSearchable={false}
                  placeholder={null}
                  components={{
                    Control: () => null,
                    IndicatorSeparator: () => null,
                    DropdownIndicator: () => null,
                  }}
                  onChange={(selected) => {
                    setLocalActiveTag(selected.value);
                    setShowTagSelect(false);
                  }}
                  onBlur={() => setShowTagSelect(false)}
                  classNamePrefix="react-select"
                  className="react-select-container"
                  styles={{
                    menu: (base) => ({
                      ...base,
                      borderRadius: "15px",
                      marginTop: "8px",
                      backgroundColor: "#fff",
                      padding: "4px",
                      zIndex: "1000",
                    }),
                    menuPortal: (base) => ({
                      ...base,
                      zIndex: 9999,
                    }),
                    option: (base, state) => ({
                      ...base,
                      borderRadius: "8px",
                      padding: "5px",
                      cursor: "pointer",
                      fontSize: "14px",
                      backgroundColor: state.isSelected
                        ? "#0195d3"
                        : state.isFocused
                          ? "#F3F9FC"
                          : "#fff",

                      color: state.isSelected
                        ? "#ffffff"
                        : "#091F28",

                      fontWeight: state.isSelected ? "200" : "300",

                      "&:active": {
                        backgroundColor: state.isSelected
                          ? "#091F28"
                          : "#F3F9FC",
                      },
                    }),
                  }}
                />
              </div>
            )} */}
          </div>

          {/* File Preview */}
          {selectedFile && (
            <div className="file-preview">
              <div className="file-name-details d-flex align-items-center">
                {previewUrl && (
                  <Image
                    src={previewUrl}
                    className="me-3 rounded"
                    style={{ objectFit: "cover" }}
                    alt="Preview"
                  />
                )}
                <div>
                  <div className="file-name">{selectedFile.name}</div>
                  <small className="file-details">
                    {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                  </small>
                </div>
              </div>
              <Button
                variant="outline-danger"
                size="sm"
                onClick={clearSelectedFile}
              >
                ×
              </Button>
            </div>
          )}

          {/* Tags */}
          {/* <div className="composer-tags">
            {availableTags.map((tag) => (
              <Badge
                key={tag}
                bg={activeTag === tag ? "primary-active" : "light-inactive"}
                text={activeTag === tag ? "white" : "dark"}
                className="cursor-pointer composer-tag"
                onClick={() => selectTag(tag)}
              >
                {tag}
              </Badge>
            ))}
          </div> */}

          {/* Old submit button — replaced by inline Post button in composer-row */}
          {/* {postContent.trim() && (
            <div className="text-end">
              <Button type="submit" variant="primary" size="sm">
                Post
              </Button>
            </div>
          )} */}
        </Form>
      </Card.Body>

      {/* Create Post Modal */}
      <CreatePostModal
        show={showCreateModal}
        onHide={() => { setShowCreateModal(false); setOpenWithPoll(false); }}
        createPost={createPost}
        categories={categories}
        isLoading={isLoading}
        preFilledContent={postContent}
        initialCategory={localActiveTag}
        onCategoryChange={setLocalActiveTag}
        onpostSubmit={onPostSubmit}
        initialShowPoll={openWithPoll}
      />
    </Card>
  );
};

export default PostComposer;
